module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/register-map-e5312dc19e879a1fd41f87b475dfcc19.png";